import { useNavigate, useParams } from "react-router-dom";
import Button from "@/components/Button";
import {
    Modal,
    ModalContent,
    ModalBody,
    ModalFooter,
    useDisclosure,
} from "@nextui-org/react";

function VideoDetail({
    maxViewsCount,
    myViewsCount,
    isLocked,
    isAttended,
    id,
}) {
    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const { courseId, lectureId, grade } = useParams();

    const navigate = useNavigate();

    return (
        <div
            className={`flex flex-col gap-4 px-4 py-3 font-semibold ${
                isLocked || !isAttended ? "bg-[#E9E9E9]" : "bg-white"
            } border-t-2 text-secondary-color`}
        >
            <p>
                - عدد المرات التي شوهدت :
                <span className="px-1 text-gray-color-primary">
                    {" "}
                    {myViewsCount}
                </span>
            </p>
            <p>
                - عدد مرات المشاهدة المتبقة :
                <span className="px-1 text-gray-color-primary">
                    {" "}
                    {maxViewsCount - myViewsCount}
                </span>
            </p>
            {isLocked || myViewsCount === maxViewsCount ? null : (
                <Button
                    type="primary"
                    disabled={isLocked || myViewsCount === maxViewsCount}
                    onClick={onOpen}
                    className="w-[90%] mx-auto"
                >
                    مشاهدة الفيديو
                </Button>
            )}

            <div>
                <Modal
                    classNames={{ base: "m-0 pb-12 md:pb-0" }}
                    isOpen={isOpen}
                    onOpenChange={onOpenChange}
                    motionProps={{
                        variants: {
                            enter: {
                                scale: "var(--scale-enter)",
                                y: "var(--slide-enter)",
                                opacity: 1,
                                transition: {
                                    scale: {
                                        duration: 0.4,
                                        ease: [0.36, 0.66, 0.4, 1],
                                    },
                                    opacity: {
                                        duration: 0.4,
                                        ease: [0.36, 0.66, 0.4, 1],
                                    },
                                    y: {
                                        type: "spring",
                                        bounce: 0,
                                        duration: 0.6,
                                    },
                                },
                            },
                            exit: {
                                scale: "var(--scale-exit)",
                                y: "var(--slide-exit)",
                                opacity: 0,
                                transition: {
                                    duration: 0.3,
                                    ease: [0.36, 0.66, 0.4, 1],
                                },
                            },
                        },
                    }}
                >
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalBody className="flex flex-col items-center justify-center pt-5 ">
                                    <img
                                        src="/images/Question.webp"
                                        alt="Question mark Image"
                                        className="w-32"
                                    />
                                    <p className="text-xl font-semibold text-secondary-color">
                                        هل انت متأكد من انك تريد بدأ الفيديو
                                        الأن ؟
                                        <span className="block pt-4 text-sm font-medium text-center text-gray-color-primary">
                                            في حالة الضغط علي زر البدأ سوف تحسب
                                            مشاهدة للفيديو
                                        </span>
                                    </p>
                                </ModalBody>
                                <ModalFooter className="flex items-center justify-center gap-5 pb-6">
                                    <Button
                                        type="primary"
                                        disabled={
                                            isLocked ||
                                            myViewsCount === maxViewsCount
                                        }
                                        className="w-36"
                                        onClick={() => {
                                            onClose();
                                            navigate(
                                                `/${grade}/courses/${courseId}/lectures/${lectureId}/video/${id}`,
                                                { replace: true }
                                            );
                                        }}
                                    >
                                        بدأ المشاهدة
                                    </Button>
                                    <Button
                                        type="customized"
                                        onClick={onClose}
                                        className="px-4 py-2 text-white rounded-full bg-gray-color-light w-36 md:px-6 "
                                    >
                                        إلغاء
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            </div>
        </div>
    );
}

export default VideoDetail;
